import {
  SET_CARDHOLDERINFO, RESET_CARDHOLDERINFO
} from '../types/suspension';
import { RESET_STATE } from '../types/global';

export interface SuspensionState {
  cardholderInfo: any
}

const INITIAL_STATE: SuspensionState = {
  cardholderInfo: null,
};

const suspensionReducer = function (state: SuspensionState = INITIAL_STATE, action): SuspensionState {
  switch (action.type) {
    case RESET_STATE:
      return INITIAL_STATE;
    case SET_CARDHOLDERINFO:
      return { ...state, cardholderInfo: action.payload };
    case RESET_CARDHOLDERINFO:
      return { ...state, cardholderInfo: null };
    default:
      return state;
  }
};

export default suspensionReducer;
